export class SupportContact {
  id: number;
  image: string;
  name: string;
  phone: string;
  email: string;
  type: string;


  constructor() {
    this.id = -1;
    this.image = '';
    this.name = '';
    this.phone = '';
    this.email = '';
    this.type = '';
  }
}
